



















































































































































































































































































































































































































































































import { Component, Vue, Prop, Watch, Inject } from "vue-property-decorator";
import { VueEditor } from "vue2-editor";
import { validationMixin } from "vuelidate";

import {
  maxLength,
  minValue,
  between,
  numeric,
} from "vuelidate/lib/validators";
import { helpers, minLength } from "vuelidate/lib/validators";

const decimalValidator = helpers.regex("decimal", /^-?\d*\.?\d+$/);

import SubmitResetButtonGroop from "@/components/app/shared/btn&dd/submit-reset-button-groop.vue";
import LanguagesBtns from "@/components/app/shared/btn&dd/languages-btns.vue";
import UploadPicture from "@/components/app/images/upload-picture.vue";
import MapPointPicker from "@/components/route-info/v2/shared/MapPointPicker.vue";
import StandartModal from "@/components/app/standart-modal.vue";

import type { CityFeature } from "@/@types/route-info/v2/v2.citys";
import type { LanguageCode, Locale } from "@/@types/_shared/locale";
import type { SICON } from "@/@types/_shared/src";

const cityCode = helpers.regex("cityCode", /^[A-Z0-9_-]+$/);
const countryCode = helpers.regex("countryCode", /^[A-Z]{2,3}$/);

@Component({
  components: {
    StandartModal,
    submit: SubmitResetButtonGroop,
    VueEditor,
    LanguagesBtns,
    UploadPicture,
    MapPointPicker,
  },
  mixins: [validationMixin],
  validations: {
    name: { minLength: minLength(1), maxLength: maxLength(100) },
    description: { maxLength: maxLength(5000) },
    names: { $each: { maxLength: maxLength(100) } },
    descriptions: { $each: { maxLength: maxLength(5000) } },
    coordinatesLongitude: {
      decimal: decimalValidator,
      between: between(-180, 180),
    },
    coordinatesLatitude: {
      decimal: decimalValidator,
      between: between(-90, 90),
    },
    country_code: { maxLength: maxLength(10), countryCode },
    country_name: { maxLength: maxLength(100) },
    region_name: { maxLength: maxLength(100) },
    population: { numeric, minValue: minValue(0) },
  },
})
class RouteInfoV2AddCity extends Vue {
  @Prop({ type: Object, default: null }) item!: CityFeature | null;
  @Inject("cityFolder") cityFolder!: string;

  currentLocale: LanguageCode =
    (this.$store.getters.getLanguages && this.$store.getters.getLanguages[0]) ||
    "ru";

  name = "";
  description = "";
  code = "";

  names: Locale = {};
  descriptions: Locale = {};

  coordinatesLongitude = "0";
  coordinatesLatitude = "0";

  show = true;

  excursion: string[] = [];
  excursionRaw: any = null;

  src_icon: SICON = { icon: "", lib: "" };
  iconRaw: any = null;
  src_poster = "";
  src_background = "";
  src_image = "";
  src_vertical_poster = "";
  src_horizontal_poster = "";

  railwayStation_coordinates_longitude = "0";
  railwayStation_coordinates_latitude = "0";
  railwayStation_properties_name = "";
  railwayStation_properties_name_locale: Locale = {};
  railwayStation_properties_address = "";
  railwayStation_properties_address_locale: Locale = {};

  riverStation_coordinates_longitude = "0";
  riverStation_coordinates_latitude = "0";
  riverStation_properties_name = "";
  riverStation_properties_name_locale: Locale = {};
  riverStation_properties_address = "";
  riverStation_properties_address_locale: Locale = {};

  attractions: string[] = [];

  country_id = "";
  country_name = "";
  country_name_locale: Locale = {};
  country_code = "";

  region_id = "";
  region_name = "";
  region_name_locale: Locale = {};
  region_code = "";

  timezone = "+3";
  population: number | null = null;

  get timezoneOptions() {
    const options = [];
    for (let i = -12; i <= 14; i++) {
      const sign = i >= 0 ? "+" : "";
      options.push({ value: `${sign}${i}`, text: `GMT${sign}${i}` });
    }
    return options;
  }

  onCoordInput(field: string, value: string): void {
    const normalized = value.replace(",", ".");
    (this as any)[field] = normalized;
  }

  onCityCoordsPicked(coords: { lat: number; lng: number }): void {
    this.coordinatesLatitude = String(coords.lat);
    this.coordinatesLongitude = String(coords.lng);
  }

  onRailwayCoordsPicked(coords: { lat: number; lng: number }): void {
    this.railwayStation_coordinates_latitude = String(coords.lat);
    this.railwayStation_coordinates_longitude = String(coords.lng);
  }

  onRiverCoordsPicked(coords: { lat: number; lng: number }): void {
    this.riverStation_coordinates_latitude = String(coords.lat);
    this.riverStation_coordinates_longitude = String(coords.lng);
  }

  get city(): CityFeature {
    return {
      _id: (this.item && this.item._id) || "",
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [
          parseFloat(String(this.coordinatesLongitude).replace(",", ".")) || 0,
          parseFloat(String(this.coordinatesLatitude).replace(",", ".")) || 0,
        ],
      },

      properties: {
        show: this.show,

        name: this.names || {},
        description: this.descriptions || {},
        code: this.code || "",
        excursion: this.excursion.length
          ? this.excursion
          : this.excursionRaw || [],

        src: {
          icon:
            this.iconRaw != null
              ? this.iconRaw
              : this.src_icon || { icon: "", lib: "" },
          poster: this.src_poster || "",
          background: this.src_background || "",
          image: this.src_image || "",
          horizontal_poster: this.src_horizontal_poster || "",
          vertical_poster: this.src_vertical_poster || "",
        },

        railwayStation: {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [
              parseFloat(
                String(this.railwayStation_coordinates_longitude).replace(
                  ",",
                  "."
                )
              ) || 0,
              parseFloat(
                String(this.railwayStation_coordinates_latitude).replace(
                  ",",
                  "."
                )
              ) || 0,
            ],
          },
          properties: {
            name: this.railwayStation_properties_name_locale || {},
            address: this.railwayStation_properties_address_locale || {},
          },
        },

        riverStation: {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [
              parseFloat(
                String(this.riverStation_coordinates_longitude).replace(
                  ",",
                  "."
                )
              ) || 0,
              parseFloat(
                String(this.riverStation_coordinates_latitude).replace(",", ".")
              ) || 0,
            ],
          },
          properties: {
            name: this.riverStation_properties_name_locale || {},
            address: this.riverStation_properties_address_locale || {},
          },
        },

        attractions: this.attractions || [],

        country: {
          id: this.country_id || "",
          name: this.country_name_locale || {},
          code: this.country_code || "",
        },

        region: {
          id: this.region_id || "",
          name: this.region_name_locale || {},
          code: this.region_code || "",
        },

        timezone: this.timezone || "",
        population: this.population || 0,
      },
    };
  }

  mounted(): void {
    this.createFields();
    this.$root.$on("bv::modal::shown", (_: any, modalId: string) => {
      if (modalId === "route-info-v2-add-city") {
        this.createFields();
      }
    });
  }

  beforeDestroy(): void {
    this.$root.$off("bv::modal::shown");
  }

  @Watch("name")
  private addName(): void {
    if (this.names[this.currentLocale] !== this.name) {
      this.$set(this.names, this.currentLocale, this.name);
    }
  }

  @Watch("description")
  private addDescription(): void {
    if (this.descriptions[this.currentLocale] !== this.description) {
      this.$set(this.descriptions, this.currentLocale, this.description);
    }
  }

  @Watch("railwayStation_properties_name")
  private addRailwayName(): void {
    this.$set(
      this.railwayStation_properties_name_locale,
      this.currentLocale,
      this.railwayStation_properties_name
    );
  }

  @Watch("railwayStation_properties_address")
  private addRailwayAddress(): void {
    this.$set(
      this.railwayStation_properties_address_locale,
      this.currentLocale,
      this.railwayStation_properties_address
    );
  }

  @Watch("riverStation_properties_name")
  private addRiverName(): void {
    this.$set(
      this.riverStation_properties_name_locale,
      this.currentLocale,
      this.riverStation_properties_name
    );
  }

  @Watch("riverStation_properties_address")
  private addRiverAddress(): void {
    this.$set(
      this.riverStation_properties_address_locale,
      this.currentLocale,
      this.riverStation_properties_address
    );
  }

  @Watch("country_name")
  private addCountryName(): void {
    this.$set(this.country_name_locale, this.currentLocale, this.country_name);
  }

  @Watch("region_name")
  private addRegionName(): void {
    this.$set(this.region_name_locale, this.currentLocale, this.region_name);
  }

  @Watch("currentLocale")
  private changeLocale(): void {
    this.name = this.names[this.currentLocale] || "";
    this.description = this.descriptions[this.currentLocale] || "";
    this.railwayStation_properties_name =
      this.railwayStation_properties_name_locale[this.currentLocale] || "";
    this.railwayStation_properties_address =
      this.railwayStation_properties_address_locale[this.currentLocale] || "";
    this.riverStation_properties_name =
      this.riverStation_properties_name_locale[this.currentLocale] || "";
    this.riverStation_properties_address =
      this.riverStation_properties_address_locale[this.currentLocale] || "";
    this.country_name = this.country_name_locale[this.currentLocale] || "";
    this.region_name = this.region_name_locale[this.currentLocale] || "";
  }

  public onSubmit(event: Event): void {
    event.preventDefault();
    this.$v.$touch();

    if (this.$v.$invalid) {
      return;
    }

    this.$emit("setCityV2", this.city);
  }

  public isClean(): void {
    this.name = "";
    this.description = "";
    this.code = "";
    this.names = {};
    this.descriptions = {};
    this.coordinatesLongitude = "0";
    this.coordinatesLatitude = "0";
    this.show = true;
    this.excursion = [];
    this.excursionRaw = null;
    this.src_icon = { icon: "", lib: "" };
    this.iconRaw = null;
    this.src_poster = "";
    this.src_background = "";
    this.src_image = "";
    this.src_vertical_poster = "";
    this.src_horizontal_poster = "";
    this.railwayStation_coordinates_longitude = "0";
    this.railwayStation_coordinates_latitude = "0";
    this.railwayStation_properties_name = "";
    this.railwayStation_properties_name_locale = {};
    this.railwayStation_properties_address = "";
    this.railwayStation_properties_address_locale = {};
    this.riverStation_coordinates_longitude = "0";
    this.riverStation_coordinates_latitude = "0";
    this.riverStation_properties_name = "";
    this.riverStation_properties_name_locale = {};
    this.riverStation_properties_address = "";
    this.riverStation_properties_address_locale = {};
    this.attractions = [];
    this.country_id = "";
    this.country_name = "";
    this.country_name_locale = {};
    this.country_code = "";
    this.region_id = "";
    this.region_name = "";
    this.region_name_locale = {};
    this.region_code = "";
    this.timezone = "+3";
    this.population = null;
    this.$v.$reset();
  }

  private toLocale(data: any): Locale {
    if (data == null) return {};
    if (typeof data === "string" && data) {
      return { [this.currentLocale]: data };
    }
    return { ...data };
  }

  @Watch("item", { immediate: true })
  private createFields() {
    if (!this.item) {
      this.isClean();
      return;
    }
    const props: any = this.item.properties || {};
    this.names = this.toLocale(props.names || props.name);
    this.descriptions = this.toLocale(props.descriptions || props.description);
    this.code = props.code || "";
    const coords = this.item.geometry && this.item.geometry.coordinates;
    this.coordinatesLongitude = String((coords && coords[0]) || 0);
    this.coordinatesLatitude = String((coords && coords[1]) || 0);
    this.show = props.show == null ? true : props.show;
    this.excursionRaw = props.excursion || null;
    this.excursion = Array.isArray(props.excursion) ? [...props.excursion] : [];
    const srcIcon = (props.src && props.src.icon) || null;
    this.iconRaw = srcIcon;
    this.src_icon =
      srcIcon && typeof srcIcon === "object" && !Array.isArray(srcIcon)
        ? { ...srcIcon }
        : { icon: "", lib: "" };
    this.src_poster = (props.src && props.src.poster) || "";
    this.src_background = (props.src && props.src.background) || "";
    this.src_horizontal_poster =
      (props.src && props.src.horizontal_poster) || "";
    this.src_vertical_poster = (props.src && props.src.vertical_poster) || "";
    this.src_image = (props.src && props.src.image) || "";
    this.railwayStation_coordinates_longitude = String(
      (props.railwayStation &&
        props.railwayStation.geometry &&
        props.railwayStation.geometry.coordinates &&
        props.railwayStation.geometry.coordinates[0]) ||
        0
    );
    this.railwayStation_coordinates_latitude = String(
      (props.railwayStation &&
        props.railwayStation.geometry &&
        props.railwayStation.geometry.coordinates &&
        props.railwayStation.geometry.coordinates[1]) ||
        0
    );
    this.railwayStation_properties_name_locale = this.toLocale(
      props.railwayStation &&
        props.railwayStation.properties &&
        props.railwayStation.properties.name
    );
    this.railwayStation_properties_name =
      this.railwayStation_properties_name_locale[this.currentLocale] || "";
    this.railwayStation_properties_address_locale = this.toLocale(
      props.railwayStation &&
        props.railwayStation.properties &&
        props.railwayStation.properties.address
    );
    this.railwayStation_properties_address =
      this.railwayStation_properties_address_locale[this.currentLocale] || "";
    this.riverStation_coordinates_longitude = String(
      (props.riverStation &&
        props.riverStation.geometry &&
        props.riverStation.geometry.coordinates &&
        props.riverStation.geometry.coordinates[0]) ||
        0
    );
    this.riverStation_coordinates_latitude = String(
      (props.riverStation &&
        props.riverStation.geometry &&
        props.riverStation.geometry.coordinates &&
        props.riverStation.geometry.coordinates[1]) ||
        0
    );
    this.riverStation_properties_name_locale = this.toLocale(
      props.riverStation &&
        props.riverStation.properties &&
        props.riverStation.properties.name
    );
    this.riverStation_properties_name =
      this.riverStation_properties_name_locale[this.currentLocale] || "";
    this.riverStation_properties_address_locale = this.toLocale(
      props.riverStation &&
        props.riverStation.properties &&
        props.riverStation.properties.address
    );
    this.riverStation_properties_address =
      this.riverStation_properties_address_locale[this.currentLocale] || "";
    this.attractions = Array.isArray(props.attractions)
      ? [...props.attractions]
      : [];
    this.country_id = (props.country && props.country.id) || "";
    this.country_name_locale = this.toLocale(
      props.country && props.country.name
    );
    this.country_name = this.country_name_locale[this.currentLocale] || "";
    this.country_code = (props.country && props.country.code) || "";
    this.region_id = (props.region && props.region.id) || "";
    this.region_name_locale = this.toLocale(props.region && props.region.name);
    this.region_name = this.region_name_locale[this.currentLocale] || "";
    this.region_code = (props.region && props.region.code) || "";
    this.timezone = props.timezone || "";
    this.population = props.population || null;
    this.changeLocale();
  }
}
export default RouteInfoV2AddCity;
